import React, { useEffect, useState } from 'react';
import './BridalMakeup.css';
import { Link } from 'react-router-dom';
import { getGroomImages } from '../../services/galleryService';

const GroomMakeup = () => {
  const [images, setImages] = useState([]);
  const [current, setCurrent] = useState(0);
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    getGroomImages().then(setImages);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [images]);

  const toggleDrawer = () => setDrawerOpen(!drawerOpen);

  return (
    <div className="bridal-page">
      <div className=" slide-up">
        <h1 className="page-title">Groom Makeup</h1>
      </div>

      <div className="gallery-section">
        {images.length > 0 && <img src={images[current]} alt="main" className="main-image" />}
        <div className="thumbnail-strip">
          {images.map((img, index) => (
            <img
              key={index}
              src={img}
              alt={`thumb-${index}`}
              className={`thumbnail ${current === index ? 'active' : ''}`}
              onClick={() => setCurrent(index)}
            />
          ))}
        </div>
      </div>

      <div className="buttons-container">
        <button className="drawer-toggle-btn" onClick={toggleDrawer}>
          All You Need to Know About Groom Makeup ▾
        </button>
        {drawerOpen && (
        <div className="drawer-content">
          <h3>Why Should Brides Get All the Compliments?</h3>
          <p>Let’s be honest — while brides are out here soaking up compliments (and looking fabulous, of course), the grooms shouldn’t be hiding in the shadows!</p>
          <p>Not anymore.</p>
          <p>Today's grooms care about how they look — and rightfully so. It's your big day too, and you deserve to feel like the best, most confident version of yourself.</p>
          <p>Now, groom glam isn’t about contouring cheekbones or shimmering eyeshadow. It’s about fresh, even-toned, undetectable makeup that makes you look like you, just a little more well-rested and glowing. You know... like you’ve been drinking 4 litres of water and sleeping 9 hours a night since forever.</p>

          <h4>👔 What We Offer for Our Dapper Grooms:</h4>
          <ul>
            <li>💄 High-Definition Makeup — lightweight, natural, and camera-ready</li>
            <li>💇‍♂️ Hair Setting — clean, sleek, and styled to perfection</li>
            <li>👕 Draping — from shawls to dupattas, we’ve got it covered!</li>
            <li>🌿 Skincare Suggestions — easy tips to get that glow, no 10-step routine required</li>
          </ul>

          <p>At Atelier by Shriji, we keep it subtle, smooth, and simple — just enough to make people say, “Wow, he looks amazing!” without ever guessing you’re wearing makeup. For more details, <a href="/make-an-enquiry">MAKE AN ENQUIRY</a></p>
        </div>
      )}
        <button className="primary-btn" onClick={() => window.location.href = "/make-an-enquiry"}>
          Make an Enquiry
        </button>

        
      </div>

      
    </div>
  );
};

export default GroomMakeup;